import { cva } from 'class-variance-authority'

export const typographyVariants = cva('', {
  variants: {
    variant: {
      h1: 'max-w-(--container-prose) font-bold font-serif text-4xl',
      h2: 'max-w-(--container-prose) font-semibold text-3xl',
      h3: 'max-w-(--container-prose) font-semibold text-lg',
      h4: 'max-w-(--container-prose) font-semibold text-base leading-6',
      h5: 'max-w-(--container-prose) font-bold text-sm leading-6',
      h6: 'max-w-(--container-prose) font-bold text-xs leading-4.5',
    },
  },
})
